import React from 'react';

const SvgUserBook = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 3C11 1.34312 9.65687 0 8 0C6.34312 0 5 1.34312 5 3C5 4.65688 6.34312 6 8 6C9.65687 6 11 4.65688 11 3ZM7.29969 7.53438C5.44562 6.39937 2.4425 6.0875 0.93125 6.00156C0.423437 5.97281 0 6.35969 0 6.84812V13.8106C0 14.2584 0.362188 14.6319 0.827812 14.6559C2.19219 14.7275 4.9525 14.9897 6.86031 15.9506C7.15312 16.0981 7.50031 15.8972 7.50031 15.5797V7.8925C7.5 7.74656 7.42781 7.61281 7.29969 7.53438ZM15.0688 6.00156C13.5578 6.08719 10.5544 6.39937 8.70063 7.53438C8.5725 7.61281 8.50031 7.75187 8.50031 7.89781V15.5787C8.50031 15.8972 8.84844 16.0984 9.14219 15.9506C11.0497 14.9906 13.8084 14.7284 15.1725 14.6569C15.6381 14.6325 16.0003 14.2591 16.0003 13.8112V6.84812C16 6.35969 15.5766 5.97281 15.0688 6.00156Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgUserBook;
